import { BaseItem, Nullable, NullablePartial } from '../common';

export enum Kind {
  AIM = 'AIM',
  Athena = 'ATHENA',
  AthenaIDX = 'ATHENAIDX',
  AthenaIDXGroupManagement = 'ATHENAIDX_GROUPMANAGEMENT',
  AthenaIDXWeb = 'ATHENAIDX_WEB',
  AthenaWeb = 'ATHENA_WEB',
  Availity = 'AVAILITY',
  Carelon = 'CARELON',
  Centricity = 'CENTRICITY',
  Cerner = 'CERNER',
  EClinicalWorks = 'ECLINICALWORKS',
  EClinicalWorksWeb = 'ECLINICALWORKS_WEB',
  Epic = 'EPIC',
  EpicAPI = 'EPIC_API',
  Evicore = 'EVICORE',
  ExternalAPI = 'EXTERNAL_API',
  FHIR = 'FHIR',
  HealthHelp = 'HEALTH_HELP',
  HL7 = 'HL7',
  Intergy = 'INTERGY',
  Meditech = 'MEDITECH',
  MedSolutions = 'MEDSOLUTIONS',
  MHK = 'MHK',
  Quartet = 'QUARTET',
  RadMD = 'RADMD',
  Revcycle = 'REVCYCLE',
  Schapptbook = 'SCHAPPTBOOK',
  UnitedHealthcare = 'UNITED_HEALTHCARE',
  Webcollect = 'WEBCOLLECT',
  Win32 = 'WIN32',
}

export type BaseEhrInstance = {
  kind: Kind;
  name: string;
  deploymentName: string;
  enableDynamicPrioritization: boolean;
  enableEncounterLocking: boolean;
  enableEncounterSorting: boolean;
  enableCopilot: boolean;
} & Nullable<{
  instance: string;
  ehrLoginUrl: string;
  gatewayAppName: string;
  gatewayEmbeddedUrl: string;
  gatewayKind: string;
  gatewayLoginUrl: string;
  gatewaySsoUrl: string;
  vpnBaseUrl: string;
  vpnLoginUrl: string;
  ehrSystemId: string;
}>;

export interface EhrInstance extends BaseItem, BaseEhrInstance {}

export interface FindAllOptions
  extends Partial<Pick<EhrInstance, 'kind' | 'ehrSystemId'>> {}
export type CreateValues = NullablePartial<BaseEhrInstance>;
export type UpdateValues = Partial<BaseEhrInstance>;

export interface EhrInstanceWithPracticeIds extends EhrInstance {
  practiceIds: string[];
}
